import React from 'react'
import styles from './index.module.less'
export default function Notpage() {
  return (
    <div className={styles.cont}>
      一片荒原...... <br />
      <a href="/">回到首页</a>
    </div>
  )
}
